import { filterConditionsExport  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    category: string;
};

export const filterConditions = ({
    category,
}: Props) => {
    let rows = filterConditionsExport(category);
    return rows
};


